import styled from '@emotion/styled';

export const SCard = styled.div`
  width: 364px;
  background: white;
  padding: 20px;
  margin: 20px;
`;
